import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import tools1Icon from "assets/images/tools1.svg";
import { useSelector } from "react-redux";
import allSitesLogo from "assets/images/grid.svg";
import supportForum from "assets/images/support-forum.svg";
import { setChatBoxVisibility } from "store/actions";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import externalLink from "assets/images/external-link1.svg";
import arrowRight from "assets/images/angle-right.svg";
import liveChatSvg from "assets/images/live-chat.svg";
const OtherTools = () => {
  const { headerMenu, headerLoading } = useSelector(state => state.Layout);
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  return (
    <div className="catalog">
      <Dropdown
        onMouseLeave={() => setShowDropdown(false)}
        onMouseOver={() => setShowDropdown(true)}
        align={"end"}
      >
        <Dropdown.Toggle id="dropdown-autoclose-true">
          <img src={allSitesLogo} alt="all sites" />
        </Dropdown.Toggle>

        <Dropdown.Menu show={showDropdown}>
          <ul>
            <h6>Curriculum</h6>
            <div className="header-main-dropdown">
              {!!!headerLoading && !!headerMenu ? (
                headerMenu
                  ?.filter(
                    x => x.title === "Grow Kids" || x.title === "Grow Students"
                  )
                  ?.map((item, i) => (
                    <li
                      key={i}
                      id={
                        item.title === "Grow Kids"
                          ? "grow-app-launcher-curriculum-grow-kids"
                          : "grow-app-launcher-curriculum-grow-students"
                      }
                    >
                      <a href={item?.link}>
                        <div className="tools-inner">
                          <div className="d-flex justify-content-center">
                            <img src={item?.icon || tools1Icon} alt="" />
                          </div>
                        </div>
                      </a>
                    </li>
                  ))
              ) : (
                <li>Loading..</li>
              )}
            </div>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <h6>CHURCH LEADER TOOLS</h6>
            <div className="main-dropdown">
              {!!!headerLoading && !!headerMenu ? (
                headerMenu?.slice(2)?.map((item, i) => (
                  <li key={i}>
                    <a
                      href={item?.link}
                      id={`grow-app-launcher-tool-${item.title
                        .toLowerCase()
                        .split(" ")
                        .join("-")}`}
                    >
                      <div className="tools-inner">
                        <div className="d-flex justify-content-center">
                          <img src={item?.icon || tools1Icon} alt="" />
                        </div>
                        <div className="tool-desc d-flex justify-content-center mt-2">
                          <span className="tool-desc-title">
                            {item?.title?.includes("Grow")
                              ? item.title.split(" ")[1] || item.title
                              : item.title}
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                ))
              ) : (
                <li>Loading..</li>
              )}
            </div>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <h6>SUPPORT</h6>
            <a
              href={"https://support.stuffyoucanuse.org/home"}
              className="support-forum cursor-pointer"
              id="grow-app-launcher-support-forum"
              rel="noreferrer"
              target={"_blank"}
              style={{ marginBottom: "10px" }}
            >
              <div className="d-flex gap-2">
                {"icon" && (
                  <span className="link-icon d-flex">
                    <img
                      src={supportForum}
                      style={{ width: "16px", height: "13px" }}
                      alt=""
                    />
                  </span>
                )}
                {
                  <span className="d-flex align-items-center">
                    Support Forum
                  </span>
                }
              </div>
              {
                <span>
                  <img
                    src={externalLink}
                    alt=">"
                    className="support-external-link"
                  />
                </span>
              }
            </a>
            <Link
              className="support-forum cursor-pointer"
              rel="noreferrer"
              id="grow-app-launcher-support-live-chat"
              onClick={() => {
                dispatch(setChatBoxVisibility("maximized"));
              }}
            >
              <div className="d-flex gap-2">
                {"icon" && (
                  <span className="link-icon d-flex">
                    <img
                      src={liveChatSvg}
                      style={{ width: "16px", height: "14px" }}
                      alt=""
                    />
                  </span>
                )}
                {
                  <span className="d-flex align-items-center">
                    Start a Live Chat
                  </span>
                }
              </div>
              {
                <span>
                  <img
                    src={arrowRight}
                    alt=">"
                    style={{ width: "6px", height: "13px" }}
                  />
                </span>
              }
            </Link>
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default OtherTools;
